export const FETCH_LOCATION = 'FETCH_SF_LOCATION'

export const FETCH_LOCATIONS = 'FETCH_SF_LOCATIONS'
export const FETCH_LOCATION_BY_GRS = 'FETCH_SF_LOCATION_BY_GRS'
export const FETCH_PLACES_OF_INTEREST = 'FETCH_SF_PLACES_OF_INTEREST'
export const FETCH_PLACE_OF_INTEREST = 'FETCH_SF_PLACE_OF_INTEREST'
export const RECEIVED_LOCATIONS = 'RECEIVED_SF_LOCATIONS'
export const RECEIVED_PLACES_OF_INTEREST = 'RECEIVED_SF_PLACES_OF_INTEREST'
export const FAILED_TO_FETCH_LOCATIONS = 'FAILED_TO_FETCH_SF_LOCATIONS'
export const FAILED_TO_FETCH_POINTS_OF_INTEREST = 'FAILED_TO_FETCH_SF_POINTS_OF_INTEREST'
